module.exports = __webpack_public_path__ + "img/menuIcon31.0f07a6df.png";